import { jsx, jsxs } from "react/jsx-runtime";
import { ChevronDown, ChevronLeft, ChevronRight, ChevronUp } from "@tamagui/lucide-icons";
import {
  Adapt,
  Button,
  Input,
  Label,
  Popover,
  XStack,
  YStack
} from "tamagui";
function PopoverDemo() {
  return /* @__PURE__ */ jsxs(XStack, { space: "$2", flex: 1, justifyContent: "center", alignItems: "center", children: [
    /* @__PURE__ */ jsx(Demo, { placement: "left", Icon: ChevronLeft, Name: "left-popover" }),
    /* @__PURE__ */ jsx(Demo, { placement: "bottom", Icon: ChevronDown, Name: "bottom-popover" }),
    /* @__PURE__ */ jsx(Demo, { placement: "top", Icon: ChevronUp, Name: "top-popover" }),
    /* @__PURE__ */ jsx(Demo, { placement: "right", Icon: ChevronRight, Name: "right-popover" })
  ] });
}
function Demo({
  Icon,
  Name,
  ...props
}) {
  return /* @__PURE__ */ jsxs(Popover, { size: "$5", allowFlip: true, ...props, children: [
    /* @__PURE__ */ jsx(Popover.Trigger, { asChild: true, children: /* @__PURE__ */ jsx(Button, { icon: Icon }) }),
    /* @__PURE__ */ jsx(Adapt, { when: "sm", platform: "touch", children: /* @__PURE__ */ jsxs(Popover.Sheet, { modal: true, dismissOnSnapToBottom: true, children: [
      /* @__PURE__ */ jsx(Popover.Sheet.Frame, { padding: "$4", children: /* @__PURE__ */ jsx(Adapt.Contents, {}) }),
      /* @__PURE__ */ jsx(Popover.Sheet.Overlay, {})
    ] }) }),
    /* @__PURE__ */ jsxs(
      Popover.Content,
      {
        borderWidth: 1,
        borderColor: "$borderColor",
        enterStyle: { x: 0, y: -10, opacity: 0 },
        exitStyle: { x: 0, y: -10, opacity: 0 },
        x: 0,
        y: 0,
        opacity: 1,
        animation: [
          "quick",
          {
            opacity: {
              overshootClamping: true
            }
          }
        ],
        elevate: true,
        children: [
          /* @__PURE__ */ jsx(Popover.Arrow, { borderWidth: 1, borderColor: "$borderColor" }),
          /* @__PURE__ */ jsxs(YStack, { space: "$3", children: [
            /* @__PURE__ */ jsxs(XStack, { space: "$3", children: [
              /* @__PURE__ */ jsx(Label, { size: "$3", htmlFor: Name, children: "Name" }),
              /* @__PURE__ */ jsx(Input, { size: "$3", id: Name })
            ] }),
            /* @__PURE__ */ jsx(Popover.Close, { asChild: true, children: /* @__PURE__ */ jsx(
              Button,
              {
                size: "$3",
                onPress: () => {
                },
                children: "Submit"
              }
            ) })
          ] })
        ]
      }
    )
  ] });
}
export {
  Demo,
  PopoverDemo
};
//# sourceMappingURL=PopoverDemo.js.map
